import {
  FormulaFields,
  ExtraFormulaFields,
  ExtendedFormulaField,
} from 'services/store/remixer/types';
import {
  BPMTag,
  DurationTag,
  EnergyTag,
  GenreTag,
  RemoveUserLoopTag,
  UserLoopTag,
} from './Tags';

type PropsType = {
  formula: ExtendedFormulaField;
};

const RemixerTag = ({ formula }: PropsType) => {
  switch (formula.field) {
    case ExtraFormulaFields.RemoveUserLoop:
      return <RemoveUserLoopTag />;

    case ExtraFormulaFields.UserLoop:
      return <UserLoopTag value={formula.value} />;

    case FormulaFields.Bpm:
      return <BPMTag value={formula.value} />;

    case FormulaFields.Duration:
      return <DurationTag value={formula.value} />;

    case FormulaFields.Energy:
      return <EnergyTag value={formula.value} />;

    case FormulaFields.Genre:
      return <GenreTag value={formula.value} />;

    default:
      return null;
  }
};

export default RemixerTag;
